export type PaymentMethodType = 'CREDIT_CARD' | 'INSTANT_BANK_ACCOUNT' | 'MANUAL_BANK_ACCOUNT';

export type PaymentMethodStatus = 'NEW' | 'VERIFIED';

export type StripePaymentMethodKind = 'card' | 'us_bank_account';

export type PaymentProduct = 'subs' | 'recruit';

export interface AffectedBusinessLocation {
    id: number;
    name: string | null;
}

export interface AssignedAddress {
    id: number;
    description: string | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zip_code: string | null;
}

export interface PaymentMethod {
    id: number;
    payment_type: PaymentMethodType;
    status: PaymentMethodStatus | null;
    is_default: boolean;
    is_recruit_default: boolean;
    brand: string | null;
    last4: string | null;
    exp_month: number | null;
    exp_year: number | null;
    cardholder_name: string | null;
    bank_name: string | null;
    affected_business_locations: AffectedBusinessLocation[];
    assigned_addresses: AssignedAddress[];
    needs_mandate: boolean;
}

export function isBankAccount(method: PaymentMethod): boolean {
    return method.payment_type === 'INSTANT_BANK_ACCOUNT' || method.payment_type === 'MANUAL_BANK_ACCOUNT';
}

export function isCreditCard(method: PaymentMethod): boolean {
    return method.payment_type === 'CREDIT_CARD';
}
